import React, {useEffect, useState} from 'react';

import {makeStyles} from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";

import Autocomplete from '@material-ui/lab/Autocomplete';
import {getData} from '../../utils/apiUtils';

const useStyles = makeStyles(() => ({
  inputStyle: {
    backgroundColor: 'white',
  },
  pointerCursor: {
    cursor: 'pointer'
  }
}));

export default function ImpactAutocomplete({id, label, initialValue, autocompleteURL, updateImpact, disabled,
                                            className, valueId, type, autofocus=false, autocompleteChars=2,
                                           autoCompleteValues=[]}) {
  const classes = useStyles();

  const [ autocompleteList, setAutocompleteList ] = useState(initialValue? [initialValue] : autoCompleteValues);
  const [ selected, setSelected ] = useState(initialValue? initialValue : '');

  useEffect(() => {
    setSelected(initialValue);
    setAutocompleteList([initialValue]);
  }, [initialValue]);

  useEffect(() => {
    setAutocompleteList(initialValue? [initialValue] : autoCompleteValues);
  }, [autoCompleteValues]);

  const onAutocompleteError = (error) => {
    // deliberately left blank.  We don't want a popup with every letter typed.
    console.log(error);
  };

  const handleAutocompleteChange = (event) => {
    const value = event.target.value;
    if (value.length >= autocompleteChars) {
      getData(autocompleteURL + value, setAutocompleteList, onAutocompleteError);
    } else {
      if (autocompleteList) {
        setAutocompleteList([autocompleteList]);
      } else {
        setAutocompleteList([]);
      }
    }

  };

  const handleSelect = (event, selectedValue) => {
    setSelected(selectedValue);
    updateImpact(valueId, type, selectedValue);
  };

  return (
      <Autocomplete
        id={id}
        options={autocompleteList}
        getOptionLabel={option => option}
        value={selected}
        size="small"
        onChange={handleSelect}
        disabled={disabled}
        className={className}
        renderInput={params => (
          <TextField {...params}
                     variant="outlined"
                     fullWidth
                     className={classes.inputStyle}
                     onChange={handleAutocompleteChange}
                     placeholder={label}
                     label={label}
                     autoFocus={autofocus? true : false}
          />
        )}
      />
  );
}
